module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$i18n.locale === 'de' || _vm.$i18n.locale === 'de-at') ? _c('home-de') : _c('home-en'), _vm._v(" "), _c('calendar'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$i18n.locale === 'de' || _vm.$i18n.locale === 'de-at') ? _c('faq-de') : _c('faq-en')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f99048f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 580
// module chunks = 0